import { type FC, type ReactNode } from 'react';
import {
  type BaseProps,
  ComponentVariant,
  type ComponentShadow,
  type ComponentAppearance,
} from 'src/modules/shared/types/component.type';
import { panelBaseClasses, panelAppearanceClasses } from './styles';

interface PanelProps extends BaseProps {
  children: ReactNode;
  isActive?: boolean;
  variant?: ComponentVariant;
  isHover?: boolean;
  shadow?: ComponentShadow;
  appearance?: ComponentAppearance;
}

export const Panel: FC<PanelProps> = ({
  children,
  shadow = 'none',
  variant = 'primary',
  isActive = false,
  isHover = false,
  appearance = 'soft',
  className = '',
}) => {
  const appearanceClasses = panelAppearanceClasses[appearance][variant];

  const shadowClasses: Record<ComponentShadow, string> = {
    inset: 'shadow-inner',
    'inset-sm': 'shadow-sm',
    flat: 'shadow-md bg-white',
    none: 'shadow-none',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
    '2xl': 'shadow-2xl',
    inner: 'shadow-inner',
  };

  const neumorphicClass = shadowClasses[shadow];

  const backgroundClass = isActive
    ? appearanceClasses.active
    : appearanceClasses.base;

  const hoverClass = isHover ? appearanceClasses.hover : '';

  const combinedClasses = [
    panelBaseClasses,
    neumorphicClass,
    backgroundClass,
    hoverClass,
    className,
  ].join(' ');

  return <div className={combinedClasses}>{children}</div>;
};
